import React, { useContext, useState, useEffect } from "react";
import { UserContext } from "../../context/UserContext";
import { Upload, Avatar } from "antd";
import { CameraOutlined } from "@ant-design/icons";
import RaiseQueryForm from "../../Components/RaiseQueries";
import SummaryApi from "../../common/index";
import axios from "axios";
import {
  Form,
  Input,
  Button,
  Card,
  Space,
  Typography,
  message,
  Spin,
  Layout,
  Menu,
  Grid,
  Tabs
} from "antd";
import {
  UserOutlined,
  ShoppingCartOutlined,
  LogoutOutlined,
  CustomerServiceOutlined
} from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import UserOrders from "../../Components/UserOrders";
import MyQueries from "../../Components/MyQueries";
import RepliedQueries from "../../Components/RepliedQueries";
import "../../Styles/UserStylings/MyAccount.css";
import UserSellerChat from "../../Components/UserSellerChat";
import AdminSupport from "./adminSupport";
import UserQueriesPage from "./adminSupport";

const { Text } = Typography;
const { Sider, Content } = Layout;
const { useBreakpoint } = Grid;
const BRAND_BLUE = "#1129ce";
const BASE_URL = process.env.REACT_APP_BACKEND_URL;

const MyAccount = () => {
  const screens = useBreakpoint();
  const { user, setUser, loading, logout } = useContext(UserContext);
  const [form] = Form.useForm();
  const [isEditing, setIsEditing] = useState(false);
  const [profilePic, setProfilePic] = useState(null);
  const [selectedTab, setSelectedTab] = useState("profile");
  const navigate = useNavigate();

  useEffect(() => {
    if (user) {
      form.setFieldsValue({
        name: user.name || "",
        mobile: user.mobile || "",
        address: user.address || "",
        homeDeliveryAddress: user.homeDeliveryAddress || "",
      });
    }
  }, [user, form]);

  const handleLogout = () => {
    logout();
    form.resetFields();
    navigate("/");
  };

  const handleSave = async () => {
    try {
      const values = await form.validateFields();
      const payload = {
        ...user,
        name: values.name,
        mobile: values.mobile,
        address: values.address,
        homeDeliveryAddress: values.homeDeliveryAddress,
      };

      const token = localStorage.getItem("token");
      await axios.put(SummaryApi.updateUserProfile.url, payload, {
        headers: { Authorization: `Bearer ${token}` },
        withCredentials: true,
      });

      setUser(payload);
      localStorage.setItem("user", JSON.stringify(payload));
      message.success("Profile updated successfully!");
      setIsEditing(false);
    } catch (err) {
      console.error(err);
      if (err.response?.status === 401) {
        logout();
        message.error("Session expired. Please login again.");
      } else {
        message.error("Failed to update profile.");
      }
    }
  };

  const handleUpload = async (file) => {
  try {
    const formData = new FormData();
    formData.append("profilePic", file);

    const token = localStorage.getItem("token");

    const res = await axios.post(SummaryApi.uploadProfilePic.url, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
        Authorization: `Bearer ${token}`,
      },
      withCredentials: true,
    });

    const newPath = res.data.profilePicUrl;  // <-- "/uploads/xxxx.png"

    // ⭐ Update context (THIS is the missing part)
    setUser(prev => ({
      ...prev,
      profilePic: newPath
    }));

    // ⭐ Update local state & force reload
    setProfilePic(`${BASE_URL}${newPath}?v=${Date.now()}`);

    message.success("Profile picture updated successfully!");
  } catch (err) {
    console.error(err);
    message.error("Failed to upload profile picture.");
  }
};


  useEffect(() => {
    if (user?.profilePic) {
    setProfilePic(`${BASE_URL}${user.profilePic}?v=${Date.now()}`);
    } else {
      setProfilePic(null);
    }
  }, [user]);

  const handleMenuClick = (e) => {
    if (e.key === "logout") {
      handleLogout();
    } else {
      setSelectedTab(e.key);
    }
  };

  const renderContent = () => {
    if (loading) return <Spin tip="Loading profile..." />;
    if (!user) return <p style={{ textAlign: "center" }}>User not logged in.</p>;

    switch (selectedTab) {
      case "profile":
  return (
    <Card
      title={
        <Text strong style={{ fontSize: 18, color: BRAND_BLUE }}>
          Personal Information
        </Text>
      }
      className="myaccount-card"
      style={{
        margin: screens.xs ? 8 : 24,
        borderRadius: 14,
        boxShadow: "0 2px 8px rgba(24,144,255,0.07)",
        maxWidth: 600,
        width: "100%",
        marginLeft: "auto",
        marginRight: "auto",
      }}
    >
      {/* FIX: PROFILE PIC DISPLAY INSIDE PERSONAL INFO (Mobile + Desktop) */}
      

      <Form form={form} layout="vertical">
        <Form.Item
          label={<Text strong>Name</Text>}
          name="name"
          rules={[{ required: true, message: "Please enter your name" }]}
        >
          <Input disabled={!isEditing} size="large" />
        </Form.Item>

        <Form.Item label={<Text strong>Email</Text>}>
          <Input value={user.email} disabled size="large" />
        </Form.Item>

        <Form.Item
          label={<Text strong>Phone</Text>}
          name="mobile"
          rules={[{ required: true, message: "Please enter phone number" }]}
        >
          <Input disabled={!isEditing} maxLength={10} size="large" />
        </Form.Item>

        <Form.Item
          label={<Text strong>Residential Address</Text>}
          name="address"
          rules={[{ required: true, message: "Please enter address" }]}
        >
          <Input.TextArea
            rows={2}
            disabled={!isEditing}
            style={{ resize: "none" }}
            placeholder="For Home Delivery"
          />
        </Form.Item>

        <Form.Item>
          {isEditing ? (
            <Space wrap>
              <Button
                type="primary"
                style={{ background: BRAND_BLUE }}
                onClick={handleSave}
              >
                Save
              </Button>
              <Button onClick={() => setIsEditing(false)}>Cancel</Button>
            </Space>
          ) : (
            <Button
              type="primary"
              style={{ background: BRAND_BLUE }}
              onClick={() => setIsEditing(true)}
            >
              Edit Profile
            </Button>
          )}
        </Form.Item>
      </Form>
    </Card>
  );

      case "orders":
        return (
          <Card
            title={<Text strong style={{ fontSize: 18, color: BRAND_BLUE }}>My Orders</Text>}
            className="myaccount-card"
            style={{
              margin: screens.xs ? 8 : 24,
              borderRadius: 14,
              boxShadow: "0 2px 8px rgba(24,144,255,0.07)",
              maxWidth: 900,
              width: "100%",
              marginLeft: "auto",
              marginRight: "auto"
            }}
          >
            <UserOrders />
          </Card>
        );

      case "admin_support":
        return (
          <Card
            title={<Text strong style={{ fontSize: 18, color: BRAND_BLUE }}>Admin Support</Text>}
            className="myaccount-card"
            style={{
              margin: screens.xs ? 8 : 24,
              borderRadius: 14,
              boxShadow: "0 2px 8px rgba(24,144,255,0.07)",
              maxWidth: 800,
              width: "100%",
              marginLeft: "auto",
              marginRight: "auto"
            }}
          >
            <UserQueriesPage/>
          </Card>
        );

      case "seller_support":
        return (
          <Card
            title={<Text strong style={{ fontSize: 18, color: BRAND_BLUE }}>Seller Support</Text>}
            className="myaccount-card"
            style={{
              margin: screens.xs ? 8 : 24,
              borderRadius: 14,
              boxShadow: "0 2px 8px rgba(24,144,255,0.07)",
              maxWidth: 900,
              width: "100%",
              marginLeft: "auto",
              marginRight: "auto"
            }}
          >
            <Tabs
              defaultActiveKey="raise"
              items={[
                {
                  key: "raise",
                  label: "Raise Query",
                  children: <RaiseQueryForm queryType="seller_support" />,
                },
                {
                  key: "my",
                  label: "My Queries",
                  children: <MyQueries type="seller" />,
                },
                {
                  key: "replied",
                  label: "Replied Queries",
                  children: <RepliedQueries type="seller" />,
                },
                {
                  key:"respond",
                  label:"Respond to Seller Replies",
                  children:<UserSellerChat type="respond_seller" />
                }
              ]}
            />
          </Card>
        );

      default:
        return null;
    }
  };

  return (
    <Layout style={{ background: "#1529ce", minHeight: "100vh" }}>
      
      {/* DESKTOP SIDEBAR */}
      <Sider
        width={screens.xs ? 0 : 220}
        collapsed={screens.xs}
        breakpoint="xs"
        style={{
          background: "#fff",
          display: screens.xs ? "none" : "flex",
          flexDirection: "column",
          alignItems: "center",
          paddingTop: screens.xs ? 8 : 32,
          boxShadow: screens.xs ? undefined : `2px 0 8px rgba(24,144,255,0.07)`,
          minHeight: "100vh",
        }}
      >
        <div style={{ textAlign: "center", marginBottom: 24 }}>
          <Upload
            showUploadList={false}
            beforeUpload={file => {
              handleUpload(file);
              return false;
            }}
          >
            <Avatar
              size={80}
              src={profilePic}
              style={{ cursor: "pointer", background: BRAND_BLUE }}
              icon={!profilePic && <CameraOutlined />}
            />
          </Upload>

          {profilePic && (
            <Button
              size="small"
              style={{ marginTop: 6 }}
              onClick={async () => {
                try {
                  const token = localStorage.getItem("token");
                  await axios.delete(SummaryApi.deleteProfilePic.url, {
                    headers: { Authorization: `Bearer ${token}` },
                  });
                  setProfilePic(null);
                  setUser(prev => ({ ...prev, profilePic: null }));
                  message.success("Profile picture removed");
                } catch (err) {
                  console.error(err);
                  message.error("Failed to remove profile picture");
                }
              }}
            >
              Remove
            </Button>
          )}

          <div style={{ fontWeight: 600, fontSize: 16, marginTop: 8 }}>
            {user?.name || "Guest"}
          </div>
        </div>

        <Menu
          mode="inline"
          selectedKeys={[selectedTab]}
          onClick={handleMenuClick}
          items={[
            { key: "profile", icon: <UserOutlined />, label: "Personal Info" },
            { key: "orders", icon: <ShoppingCartOutlined />, label: "My Orders" },
            { key: "admin_support", icon: <CustomerServiceOutlined />, label: "Admin Support" },
            { key: "seller_support", icon: <CustomerServiceOutlined />, label: "Seller Support" },
          ]}
          style={{
            fontSize: 17,
            fontWeight: 600,
            marginTop: 10,
            width: "100%",
            borderRight: 0,
            background: "#fff"
          }}
        />

        {!screens.xs && (
          <Button
            type="primary"
            danger
            icon={<LogoutOutlined />}
            block
            style={{ marginTop: 28, fontWeight: 600 }}
            onClick={handleLogout}
          >
            Logout
          </Button>
        )}
      </Sider>

      <Layout style={{ background: "#fafcff" }}>
        <Content style={{ minHeight: "100vh", padding: screens.xs ? 0 : 24 }}>
          {screens.xs && (
            <div style={{ textAlign: "center", padding: "16px 0", background: "#fff" }}>
              
              <Upload
                showUploadList={false}
                beforeUpload={file => {
                  handleUpload(file);
                  return false;
                }}
              >
                <Avatar
                  size={80}
                  src={profilePic}
                  style={{ cursor: "pointer", background: BRAND_BLUE }}
                  icon={!profilePic && <CameraOutlined />}
                />
              </Upload>

              {profilePic && (
                <Button
                  size="small"
                  style={{ marginTop: 6 }}
                  onClick={async () => {
                    try {
                      const token = localStorage.getItem("token");
                      await axios.delete(SummaryApi.deleteProfilePic.url, {
                        headers: { Authorization: `Bearer ${token}` },
                      });
                      setProfilePic(null);
                      setUser(prev => ({ ...prev, profilePic: null }));
                      message.success("Profile picture removed");
                    } catch (err) {
                      console.error(err);
                      message.error("Failed to remove profile picture");
                    }
                  }}
                >
                  Remove
                </Button>
              )}

              <div style={{ fontWeight: 600, fontSize: 16, marginTop: 8 }}>
                {user?.name || "Guest"}
              </div>
            </div>
          )}

          {/* MOBILE TOP MENU */}
          {screens.xs && (
            <Menu
              mode="horizontal"
              selectedKeys={[selectedTab]}
              onClick={handleMenuClick}
              items={[
                { key: "profile", icon: <UserOutlined />, label: "Personal Info" },
                { key: "orders", icon: <ShoppingCartOutlined />, label: "My Orders" },
                { key: "admin_support", icon: <CustomerServiceOutlined />, label: "Admin Support" },
                { key: "seller_support", icon: <CustomerServiceOutlined />, label: "Seller Support" },
                { key: "logout", icon: <LogoutOutlined />, label: "Logout" },
              ]}
              style={{
                fontSize: 16,
                fontWeight: 500,
                margin: "0",
                width: "100%",
                borderBottom: "1px solid #eee",
                background: "#fffffa"
              }}
            />
          )}

          {screens.xs && selectedTab === "logout" ? (
            <Card
              title={<Text strong style={{ fontSize: 18, color: BRAND_BLUE }}>Logout</Text>}
              className="myaccount-card"
              style={{
                margin: screens.xs ? 8 : 24,
                borderRadius: 14,
                boxShadow: "0 2px 8px rgba(24,144,255,0.07)",
                maxWidth: 400,
                width: "100%",
                marginLeft: "auto",
                marginRight: "auto"
              }}
            >
              <p>Are you sure you want to log out?</p>
              <Button style={{background:"#EE152D"}} block onClick={handleLogout}>
                Logout
              </Button>
            </Card>
          ) : renderContent()}
        </Content>
      </Layout>
    </Layout>
  );
};

export default MyAccount;
